document.querySelector('.footer__links-title--contact')?.addEventListener('click', () => {
	document.querySelector('.footer__contact-content')?.classList.toggle('footer__contact-content--show');
	document.querySelector('.footer__links-title--contact .footer__collapse-icon')?.classList.toggle('footer__collapse-icon--open');
});

document.querySelector('.footer__links-title--service')?.addEventListener('click', () => {
	document.querySelector('.footer__service-content')?.classList.toggle('footer__service-content--show');
	document.querySelector('.footer__links-title--service .footer__collapse-icon')?.classList.toggle('footer__collapse-icon--open');
});
